// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCOUyzRm2f2xARHziU6OPrEJn62wzzk7Ek",
  authDomain: "bodyworks-training.firebaseapp.com",
  projectId: "bodyworks-training",
  storageBucket: "bodyworks-training.firebasestorage.app",
  messagingSenderId: "79089940042",
  appId: "1:79089940042:web:7585c3fca979a0ae98d8b3",
  measurementId: "G-F705RMLSRY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };
